// Событийный контракт модуля `characters`.
//
// Socket.IO-событий у модуля НЕТ, и это решение, а не пропуск: всё, что должно
// доехать до других поверхностей (счётчик сообщений, время последнего ответа),
// живёт в синкаемой `character_sessions` — PowerSync обновляет список, карточку
// и деталь без единого ручного `invalidate`. Дублировать это ephemeral-событием
// значило бы завести второй путь к тем же данным.
//
// Inngest-событий тоже нет: чат — интерактивный поток, а не durable-генерация
// (итог сессии и scorecard — Ш7.3, придут вместе со своей функцией).
//
// Что здесь есть — контракт SSE-кадров BFF. Он общий для сервера и клиента, и
// без общего объявления две стороны разъезжаются молча: сервер шлёт `citation`,
// клиент ждёт `citations` — и цитаты просто не появляются.
import { z } from "zod";

/**
 * Цитата ответа. Строится ЛОКАЛЬНО по `sourceMap` (`s1 → {materialId, chunkId}`):
 * наружу уходили непрозрачные ссылки, обратно они разворачиваются у нас.
 * Партнёр наших id не видел и не увидит (§8 федерации).
 */
export const characterCitationSchema = z.object({
	/** Ссылка, которую проставила модель: `s1`, `s2`… */
	ref: z.string(),
	materialId: z.string().uuid(),
	chunkId: z.string().uuid(),
	page: z.number().int().positive().optional(),
	title: z.string().optional(),
});
export type CharacterCitation = z.infer<typeof characterCitationSchema>;

/**
 * Кадр SSE от нашего BFF клиенту.
 *
 * `moderated` — не «ошибка»: ответ партнёра обрезан НАШИМ фильтром, и молча
 * оборвать поток здесь означало бы показать пользователю зависший ответ вместо
 * объяснения (`rules/logging.md` §13a — деградация обязана кричать).
 */
export const characterStreamFrameSchema = z.discriminatedUnion("type", [
	z.object({ type: z.literal("token"), text: z.string() }),
	z.object({ type: z.literal("citations"), items: z.array(characterCitationSchema) }),
	z.object({ type: z.literal("moderated"), category: z.enum(["inappropriate"]) }),
	z.object({
		type: z.literal("done"),
		finishReason: z.string().nullable(),
		/** Id assistant-сообщения у партнёра — для TTS autoplay/replay. */
		assistantMessageId: z.string().uuid().optional(),
	}),
	z.object({
		type: z.literal("error"),
		/** Класс отказа из `ExternalModuleFailure` либо наш код (`QUOTA_EXCEEDED`…). */
		code: z.string(),
		/** true — квота возвращена: клиенту нечего списывать повторно. */
		refunded: z.boolean().default(false),
	}),
]);
export type CharacterStreamFrame = z.infer<typeof characterStreamFrameSchema>;
